export enum FiApplicationLanguageLabelType {
    Common = 0,
    DocumentAISample = 1,
    ChecklistV2AISample = 2,
}
